<template>
    <component :is="component" v-if="component" :itemData="itemData"
    :itemCategoryList="itemCategoryList"/>
</template>

<script>
    export default {
        name: "ItemWriteLink",
        mixins: [],
        components: {},
        provide() {
            return {}
        },
        props: {
            writeLayout: {},
            itemData: {
                type : Object,
                default: () =>{
                    return {}
                }
            },
            itemCategoryList:{
                type : Array,
                default: () =>{
                    return []
                }
            }

        },
        data() {
            return {
                component: null,
            }
        },
        created() {},
        mounted() {
            this.writeLoader()
        },
        beforeDestroy() {},
        destroyed() {},
        computed: {
            loader() {
                if (!this.writeLayout) {
                    return null
                }
                return () => import(`@/template/item/write/${this.writeLayout}`)
            },
        },
        methods: {
            writeLoader() {
                this.loader()
                    .then(() => {
                        this.component = () => this.loader()
                    })
                    .catch(() => {
                        this.component = () => import('@/template/item/write/ItemWriteDefaultLayout')
                    })
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>
